<div class="card bg-dark-lighter text-white">
  <div class="card-header">
    {{ title + ' Portfolio' | uppercase }}
  </div>
  <div class="card-body">
    <ng-container *ngIf="title == 'Wallet'">
      <fx-portfolio-chart-base
        [channels]="channel"
        [data]="total"
        [currency]="currency">
      </fx-portfolio-chart-base>
    </ng-container>
    <ng-container *ngIf="title != 'Wallet'">
      <fx-portfolio-chart
        [channels]="channel"
        [data]="total"
        [currency]="currency">
      </fx-portfolio-chart>
    </ng-container>
    <table class="table-profit table-bordered">
      <tbody>
        <tr *ngFor="let item of listExchange">
          <td>
            <span class="circle" [ngStyle]="{'background-color': item.color}"></span>
            <span>{{item.name}}</span>
          </td>
          <td class="text-end">
            <span class="text-{{(total[item.value] > 0)  ? 'green' : (total[item.value] < 0) ? 'red' : 'yellow'}}" title="{{total[item.value]}}">
              <span labelNumber="{{total[item.value]}}" [currency]="currency" [emo]="'1'"></span>
            </span
            >
          </td>
        </tr>
      </tbody>
    </table>
    <div class="fs-18">
      <span>SUMMARY</span>
      <ng-container *ngIf="title == 'Profit'">
        <span class="pull-right text-{{(total.total > 0)  ? 'green' : (total.total < 0) ? 'red' : 'yellow'}}">
          <span labelNumber="{{total.total}}" [currency]="currency" [emo]="'1'"></span>
        </span>
      </ng-container>
      <ng-container *ngIf="title == 'Wallet'">
        <span class="pull-right text-{{(total.wallet > 0)  ? 'green' : (total.wallet < 0) ? 'red' : 'yellow'}}">
          <span labelNumber="{{total.wallet}}" [currency]="currency" [emo]="'1'"></span>
        </span>
      </ng-container>
    </div>
  </div>
</div>
